export const cnpjValidator = (cnpj: string): boolean => {
  if (!cnpj) return false;

  const c = String(cnpj)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');

  if (c.length !== 14) return false;

  if (!/^[A-Z0-9]{12}\d{2}$/.test(c)) return false;

  if (/^0{14}$/.test(c)) return false;

  const getCharValue = (char: string): number => char.charCodeAt(0) - 48;

  const b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  let n = 0;
  for (let i = 0; i < 12; i++) {
    n += getCharValue(c[i]) * b[i + 1];
  }
  const digit1 = n % 11 < 2 ? 0 : 11 - n % 11;
  if (getCharValue(c[12]) !== digit1) return false;

  n = 0;
  for (let i = 0; i <= 12; i++) {
    n += getCharValue(c[i]) * b[i];
  }
  const digit2 = n % 11 < 2 ? 0 : 11 - n % 11;
  if (getCharValue(c[13]) !== digit2) return false;

  return true;
};